﻿import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tag } from "@blueprintjs/core";
import './Status.css';
import classNames from 'classnames';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function StatusBlock(
    {
        background = '',
        hollow = false,
        bold = true,
        status = '',
        large = true,
        children
    }
) {
    const [backgroundColor, setBackgroundColor] = useState('00C6B2');
    const [contrastMode, setContrastMode] = useState(false);

    useEffect(() => {
        let newBackgroundColor = '00C6B2';

        const hexLength = 6;
        const redByteStart = 0;
        const redByteEnd = 2;
        const greenByteEnd = 4;
        const blueByteEnd = 6;

        const redBrightness = 0.299;
        const greenBrightness = 0.587;
        const blueBrightness = 0.114;
        const contrastThreshold = 186;

        if (background) {
            newBackgroundColor = background;

            if (background.length === hexLength) {
                var red = parseInt(background.substring(redByteStart, redByteEnd), 16);
                var green = parseInt(background.substring(redByteEnd, greenByteEnd), 16);
                var blue = parseInt(background.substring(greenByteEnd, blueByteEnd), 16);

                setContrastMode((red * redBrightness + green * greenBrightness + blue * blueBrightness) > contrastThreshold);
            }
        }

        switch (status?.toLowerCase()) {
            case 'away':
            case 'amber':
                newBackgroundColor = 'FF7454';
                break;
            case 'inactive':
            case 'red':
                newBackgroundColor = 'EC2D6D';
                break;
            default:
                break;
        }

        setBackgroundColor(newBackgroundColor);
    }, [background, status])

    let size;
    if (large) {
        size = "large";
    }

    return (
        <Tag
            size={size}
            className={classNames("status-block", { "hollow": hollow, "not-bold": !bold, "dark": contrastMode })}
            style={{ backgroundColor: hollow ? 'transparent' : `#${backgroundColor}`, borderColor: `#${backgroundColor}`, color: hollow ? `#${backgroundColor}` : '' }}
        >
            {children}
        </Tag>
    );
}

StatusBlock.propTypes = {
    background: PropTypes.string,
    children: PropTypes.node,
    hollow: PropTypes.bool,
    bold: PropTypes.bool,
    status: PropTypes.string,
    large: PropTypes.bool
};